import React, { useState } from "react";
import "./StepIndicator.css";
const StepIndicator = () => {
  const [activeStep, setActiveStep] = useState(1);

  // Define the content for each step
  const stepData = [
    {
      step: 1,
      title: "Assess Your Brand",
      description:
        "Use the kit’s tools to evaluate your brand’s identity, market positioning, and customer perceptions. A thorough checklist ensures nothing is overlooked.",
      imgSrc: "https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/step1.svg",
    },
    {
      step: 2,
      title: "Analyse Findings",
      description:
        "Leverage insights from your assessments to strategies. With templates and expert guidance, uncover areas for improvement in brand positioning and customer experience.",
        imgSrc: "https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/step2.svg",
    },
    {
      step: 3,
      title: "Implement Actionable Insights",
      description:
        "Get in touch with experts who can help you apply what you’ve learned efficiently, refine your brand strategy and resonate with your audience effectively.",
        imgSrc: "https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/step3.svg",
    },
  ];

  // Get the content for the active step
  const { title, description, imgSrc } = stepData[activeStep - 1];

  const handleStepClick = (step) => {
    setActiveStep(step);
  };

  return (
    <div className="step-indicator-container">
      <div className="steps-container">
        {[1, 2, 3].map((step) => (
          <div
            key={step}
            className={`step ${activeStep === step ? "active" : ""}`}
            onClick={() => handleStepClick(step)}
          >
            Step {step}
          </div>
        ))}
      </div>

      <div className="step-content">
        <img src={imgSrc} alt={`Step ${activeStep} illustration`} className="step-image" />
        <div className="step-text">
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default StepIndicator;
